import React from 'react'
import { graphql } from 'gatsby'

import { MarkdownListQueryType } from '~/types/post.types'

import { postItemMapper, postListMapper } from '~/utils/queryUtils'
import { useRelatedPost } from '~/hooks/post'

import Layout from '~/components/Layout'
import { Contents, PostHead } from '~/components/Post'
import CommentWidget from '~/components/Post/CommentWidget'
import PostLink from '~/components/Post/PostLink'
import CustomError from '~/pages/404'
import ProfileCard from '~/components/ProfileCard'

type Props = { data: MarkdownListQueryType }

const PostTemplate: React.VFC<Props> = ({ data }) => {
  const { id, html = '', frontmatter, timeToRead } = postItemMapper(postListMapper(data)[0])

  if (frontmatter.status !== 'public') {
    return <CustomError description="작성 중 또는 비공개 처리된 글 입니다." />
  }

  const relatedPost = useRelatedPost(id)
  const { title, summary } = frontmatter

  return (
    <Layout title={title} image={frontmatter?.thumbnail.publicURL} description={summary}>
      <PostHead {...frontmatter} timeToRead={timeToRead} />
      <Contents html={html} />

      <PostLink {...relatedPost} />
      <ProfileCard />
      <CommentWidget />
    </Layout>
  )
}

export const queryPostDetail = graphql`
  query queryMarkdownDataBySlug($slug: String) {
    allMarkdownRemark(filter: { fields: { slug: { eq: $slug } } }) {
      edges {
        node {
          id
          html
          timeToRead
          excerpt(pruneLength: 200, truncate: true)
          frontmatter {
            title
            summary
            date
            tags
            thumbnail {
              childImageSharp {
                gatsbyImageData
              }
              publicURL
            }
            status
          }
        }
      }
    }
  }
`

export default PostTemplate
